import { createAsyncThunk, createSlice, original } from "@reduxjs/toolkit";
import { type RootState } from "../../app/store";
import { JOB_SERVER_URL } from "../../config";
import http from "../../net/http-common";
import { getSingleSmileData } from "./admetAPIs";

interface stateType {
  status: string;
  properties: {
    data: any;
    loading: boolean;
    singleSmileData: any;
    singleSmileForBridge: string;
    dataOnSingleSmile?: {
      data: any;
      status: "pending" | "success" | "watched" | "error";
    };
  };
}

const initialState: stateType = {
  status: "idle",
  properties: {
    data: [],
    loading: false,
    singleSmileData: null,
    singleSmileForBridge: "",
    dataOnSingleSmile: {
      data: null,
      status: "watched",
    },
  },
};

export const fetchAdmeProperties = createAsyncThunk(
  "admeProperties/fetchAdmeProperties",
  async (task_id: string) => {
    return http
      .get(
        `${JOB_SERVER_URL}/adme_tox/results?task_id=${task_id}&as_file=false`
      )
      .then((response) => response.data)
      .catch((error) => {
        console.log(error);
      });
  }
);

// set data when user enters single smile value
export const fetchSingleSmileData = createAsyncThunk(
  "admeProperties/fetchSingleSmileData",
  async ({ smileName }: { smileName: string }, { dispatch }) => {
    try {
      const response = await getSingleSmileData({ smileName });
      return response.data;
    } catch (error: any) {
      return { error };
    }
  }
);

const admePropertiesSlice = createSlice({
  name: "admeProperties",

  initialState,
  reducers: {
    setProperties(state, action) {
      ////console.log(action);
    },
    setSingleSmileData(state, action) {
      state.properties.singleSmileData = action.payload;
    },
    setSingleSimleForBridge(state, action) {
      //    //console.log("acion", action.payload);

      state.properties.singleSmileForBridge = action.payload;
    },
    setSingleSmileDataFromADMEPage(state, action) {
      state.properties.dataOnSingleSmile.data = action.payload;
    },
    updateSmilesById(state, action) {
      const { id } = action.payload;
      const sliceData = original(state.properties);

      state.properties.singleSmileData = {
        ...sliceData.singleSmileData,
        id: id,
        data: sliceData.data.results[
          sliceData.singleSmileData.evaluationIds[id] - 1
        ],
      };
    },
  },
  extraReducers: (builder) => {
    // Fetch Properties
    builder
      .addCase(
        fetchAdmeProperties.fulfilled,
        (state: stateType, action: any) => {
          state.properties.data = action.payload;
          state.properties.loading = false;
        }
      )
      .addCase(fetchAdmeProperties.rejected, (state, action: any) => {
        state.properties.loading = false;
      })
      .addCase(fetchAdmeProperties.pending, (state) => {
        state.properties.loading = true;
      })

      .addCase(
        fetchSingleSmileData.fulfilled,
        (state: stateType, action: any) => {
          state.properties.dataOnSingleSmile.data = action.payload;
          state.properties.dataOnSingleSmile.status = "success";
        }
      )
      .addCase(fetchSingleSmileData.rejected, (state, action: any) => {
        state.properties.dataOnSingleSmile.status = "error";
        // console.log("status", state.properties.dataOnSingleSmile.status);
      })
      .addCase(fetchSingleSmileData.pending, (state) => {
        state.properties.dataOnSingleSmile.status = "pending";
      });
  },
});

export const {
  setProperties,
  setSingleSmileData,
  setSingleSimleForBridge,
  setSingleSmileDataFromADMEPage,
  updateSmilesById,
} = admePropertiesSlice.actions;
export const selectAdmetProperties = (state: RootState) => state.admeProperty;
export default admePropertiesSlice.reducer;
